import {
  AppRootElementBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { VisitListener } from '@backstage/plugin-home';
import { NotificationListener } from '@tranzact/backstage-plugin-notifications';

// Mounted for their side effects only, so nothing shows when they are missing.
// plugin-home ships this same VisitListener as `home/visit-listener`, disabled
// by default; drop ours when home is consumed natively or visits count twice.
export const rootElementsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    AppRootElementBlueprint.make({
      name: 'visit-listener',
      params: { element: <VisitListener /> },
    }),
    AppRootElementBlueprint.make({
      name: 'notification-listener',
      params: { element: <NotificationListener /> },
    }),
  ],
});
